import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
export const capitalize = (str) => {
    return (str[0] ?? '').toUpperCase() + str.slice(1);
};
export const handleAccountsWithSameLabels = ({ displayLabel, allWalletAccountObjects, source, label, id, }) => {
    const sameLabelWalletAccounts = allWalletAccountObjects.filter((acct) => acct.source === source && acct.label === label);
    const sameLabelIndex = sameLabelWalletAccounts.findIndex((acct) => acct.id === id);
    if (sameLabelWalletAccounts.length > 1) {
        return `${displayLabel} ${sameLabelIndex + 1}`;
    }
    return displayLabel;
};
export const handleLongAccountName = ({ displayLabel, maxLength, }) => {
    if (maxLength && displayLabel.length > maxLength) {
        displayLabel = displayLabel.slice(0, maxLength - 1) + '…';
    }
    return displayLabel;
};
const getProperNameSelectorFactory = (namesSelector, getSelector) => createSelector(namesSelector, getSelector, (walletAccountNames, getWalletAccount) => (walletAccountName, { maxLength } = {}) => {
    if (!walletAccountNames.includes(walletAccountName))
        return null;
    const walletAccount = getWalletAccount(walletAccountName);
    const allWalletAccountObjects = walletAccountNames.map(getWalletAccount);
    const { source, label, id } = walletAccount;
    let displayLabel = label || capitalize(source);
    displayLabel = handleLongAccountName({
        displayLabel,
        maxLength,
    });
    if (source !== 'exodus') {
        displayLabel = handleAccountsWithSameLabels({
            label,
            displayLabel,
            id,
            source,
            allWalletAccountObjects,
        });
    }
    return displayLabel;
});
const getProperNameSelectorDefinition = defineSelectorFactory({
    id: 'getProperName',
    selectorFactory: getProperNameSelectorFactory,
    dependencies: [
        { selector: 'names' },
        { selector: 'get' },
    ],
});
export default getProperNameSelectorDefinition;
